"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link");
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _control = _interopRequireDefault(require("@/components/customPage/control.vue"));
var _choose = _interopRequireDefault(require("@/components/customPage/choose.vue"));
var _matrix = _interopRequireDefault(require("@/components/customPage/matrix.vue"));
var _advertising = _interopRequireDefault(require("@/components/customPage/advertising.vue"));
var _selectCategory = _interopRequireDefault(require("@/components/customChildren/selectCategory.vue"));
var _slider = _interopRequireDefault(require("@/components/customPage/slider.vue"));
var _select = _interopRequireDefault(require("@/components/photoSelect/select.vue"));
var _select2 = _interopRequireDefault(require("@/components/hyperlinkSelect/select.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    control: _control.default,
    choose: _choose.default,
    matrix: _matrix.default,
    advertising: _advertising.default,
    photoSelect: _select.default,
    hyperlinkSelect: _select2.default,
    slider: _slider.default,
    selectCategory: _selectCategory.default
  },
  data: function data() {
    return {
      url: '',
      link: {},
      activeIndex: 0,
      options: [{
        value: 4,
        label: '4X4'
      }, {
        value: 5,
        label: '5X5'
      }, {
        value: 6,
        label: '6X6'
      }, {
        value: 7,
        label: '7X7'
      }],
      imgData: [{
        value: 1,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/1-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/1-b.png',
        number: 1
      }, {
        value: 2,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/2-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/2-b.png',
        number: 2
      }, {
        value: 3,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/3-1-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/3-1-b.png',
        number: 3
      }, {
        value: 4,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/3-2-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/3-2-b.png',
        number: 3
      }, {
        value: 5,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/4-1-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/4-1-b.png',
        number: 4
      }, {
        value: 6,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/4-2-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/4-2-b.png',
        number: 4
      }, {
        value: 7,
        src: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/5-a.png',
        active: 'http://qmxq.oss-cn-hangzhou.aliyuncs.com/package/5-b.png',
        number: 0
      }]
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {
    linkInfo: {
      get: function get() {
        var index = this.activeIndex;
        if (this.content.data.length > 0) {
          return this.content.data[index];
        } else {
          return {
            url: '',
            link: {
              link: '',
              name: '',
              name1: ''
            }
          };
        }
      },
      set: function set() {}
    },
    content: {
      get: function get() {
        return this.$store.getters.content;
      },
      set: function set(value) {
        var data = {
          key: 'content',
          value: value
        };
        data = JSON.parse(JSON.stringify(data));
        this.$store.commit('finish/setAttribute', data);
      }
    },
    facade: {
      get: function get() {
        return this.$store.getters.facade || {
          page_margin: 0
        };
      },
      set: function set(value) {
        var data = {
          key: 'facade',
          value: value
        };
        this.$store.commit('finish/setAttribute', data);
      }
    }
  },
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {
    'content.style': function contentStyle(value) {
      this.activeIndex = 0;
      var number = this.imgData[value - 1].number || 1;
      if (value == 7) {
        if (this.content.data.length) {
          var _data = this.content.data[0];
          if (_data.columnEnd && _data.rowEnd) {
            return;
          } else {
            this.content.data = [];
          }
        } else {
          this.content.data = [];
        }
      } else {
        this.initialize(number);
      }
    }
  },
  /**
   * 页面渲染前
   * @return {[type]} [description]
   */
  created: function created() {},
  /**
   * 页面加载执行
   * @return {[type]} [description]
   */
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var index, number;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            index = this.content.style;
            number = this.imgData[index - 1].number || 1;
            if (this.content.data.length === 0) {
              this.initialize(number);
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    /**
     * 初始化处理此
     * @return {[type]} [description]
     */
    initialize: function initialize() {
      var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.content.data = this.handleArray(number);
    },
    /**
     * 预留个数
     * @return {[type]} [description]
     */
    handleArray: function handleArray(num) {
      var data = JSON.parse(JSON.stringify(this.content.data));
      var array = [];
      for (var i = 0; i < parseInt(num); i++) {
        if (data[i]) {
          array.push(data[i]);
        } else {
          array.push({
            title: '',
            url: '',
            link: {
              link: '',
              name: '',
              name1: ''
            }
          });
        }
      }
      return array;
    },
    uploadIconAction: function uploadIconAction(res, file) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.linkInfo.url = img[0];
      }, 1);
    },
    delImg: function delImg(key) {
      this.linkInfo.url = '';
    },
    setCategory: function setCategory() {
      this.$refs.setCategoryView.changeshow(this.linkInfo.link);
    },
    selectMessage: function selectMessage(data) {
      this.linkInfo.link = data.data;
    }
  }
};
exports.default = _default;